var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("" + (_vm.home ? 'avatar-home' : ''))},[_c('vs-avatar',{attrs:{"size":_vm.size,"circle":""}},[_c('img',{attrs:{"src":_vm.config.avatarPath}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }